import { http } from "@di";
import repositories from "./repositories";
import useCases from "./usecases";
import actions from "./actions";
import presenters from "./presenter";
const cRepositorires = repositories(http);
const cUseCases = useCases(cRepositorires);
const cActions = actions();
const cPresenters = presenters(cUseCases, cActions);
export default {
    downloadReport: cPresenters.downloadReport,
};
